import {ActionContext} from "vuex";
import {Content} from "../../../../presentation/views/content/helpers";
import {getCurrentQuestion, QuestionnaireState} from "./questionnaire";
import {getCurrentContentExercise} from "./exercise";

class QuestionnaireControlState {
  previousPage: number | null = null;
  currentPage: number | null = null;
  nextPage: number | null = null;
  lastPage: number | null = null;
}

const state = new QuestionnaireControlState();

const mutations = {
  SET_PREVIOUS_PAGE(state: QuestionnaireControlState, page: number) {
    state.previousPage = page;
  },
  SET_CURRENT_PAGE(state: QuestionnaireControlState, page: number) {
    state.currentPage = page;
  },
  SET_NEXT_PAGE(state: QuestionnaireControlState, page: number) {
    state.nextPage = page;
  },
  SET_LAST_PAGE(state: QuestionnaireControlState, page: number) {
    state.lastPage = page;
  }
};

type QuestionnaireControlActionContext = ActionContext<QuestionnaireControlState, QuestionnaireState>;

const actions = {
  reload(ctx: QuestionnaireControlActionContext) {
    const exercise = getCurrentContentExercise(ctx);
    const question = getCurrentQuestion(ctx);

    const currentPage: number = question.page;
    const previousPage: number | null = currentPage > 1 ? currentPage - 1 : null;

    const lastPage: number = exercise.numberOfQuestions;
    const nextPage: number | null = currentPage + 1 <= lastPage ? currentPage + 1 : null;

    ctx.commit("SET_PREVIOUS_PAGE", previousPage);
    ctx.commit("SET_CURRENT_PAGE", currentPage);
    ctx.commit("SET_NEXT_PAGE", nextPage);
    ctx.commit("SET_LAST_PAGE", lastPage);
  },

  async loadPrevious(ctx: QuestionnaireControlActionContext) {
    try {
      const previousPage = ctx.state.previousPage;
      await ctx.dispatch("content_module/questionnaire/setCurrentQuestion", previousPage, {root: true});
    } catch (e) {
      console.error("[loadPrevious] Error setCurrentContent ", e);
      throw e;
    }
  },

  async loadNext(ctx: QuestionnaireControlActionContext) {
    try {
      const nextPage = ctx.state.nextPage;
      await ctx.dispatch("content_module/questionnaire/setCurrentQuestion", nextPage, {root: true});
    } catch (e) {
      console.error("[loadNext] Error setCurrentContent ", e);
      throw e;
    }
  }
};

const getters = {
  hasNext: (state: QuestionnaireControlState) => state.nextPage != null,
  hasPrevious: (state: QuestionnaireControlState) => state.previousPage != null,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}